import { Collapsible } from "@/design-system/Collapsible/Collapsible";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";

/** The small caps heading a foldout wears, for headings that sit beside one. */
export const FOLDOUT_HEADING =
  "text-[10px] font-semibold uppercase tracking-[0.14em] text-foreground";

/** A small caps heading with a caret that folds its content away. */
export const Foldout = ({
  label,
  open,
  onToggle,
  action,
  children,
}: {
  label: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  /** Beside the heading, e.g. an action that must stay reachable while folded. */
  action?: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col">
    <div className="flex items-center gap-x-3">
      <button
        type="button"
        aria-expanded={open}
        onClick={onToggle}
        className={cn(FOLDOUT_HEADING, "flex items-center gap-x-1.5")}
      >
        {label}
        <ChevronDown
          size={14}
          className={cn(
            "transition-transform duration-200",
            !open && "-rotate-90",
          )}
        />
      </button>
      {action}
    </div>
    {/* Spacing inside, so a closed foldout leaves no gap. */}
    <Collapsible open={open}>
      <div className="pt-3">{children}</div>
    </Collapsible>
  </div>
);
